<template>
  <div>
    <p id="title" class="text-center">Preguntas frecuentes</p>

  <div class="accordion" id="accordionFAQS">
    <div
      class="accordion-item"
      v-for="(preguntas, index) in faqs"
      v-bind:key="index"
    >
      <h2 class="accordion-header" v-bind:id="'header' + index">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          v-bind:data-bs-target="'#collapse' + index"
          aria-expanded="true"
          v-bind:aria-controls="'collapse' + index"
        >
          {{ preguntas.question }}
        </button>
      </h2>
      <div
        v-bind:id="'collapse' + index"
        class="accordion-collapse collapse"
        aria-labelledby="headingOne"
        data-bs-parent="#accordionExample"
      >
        <div class="accordion-body">
          {{ preguntas.answer }}
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "FAQS",
  props: {
    msg: String,
  },
  data() {
    return {
      faqs: [
        {
          question: "¿Qué es CUCMA (Cobertura Universal Cáncer de Mama)?",
          answer:
            "Es un programa que busca brindar cobertura universal a las pacientes con cáncer de mama mediante el tamizaje y diagnóstico oportuno, atención integral y seguimiento hasta la recuperación o cuidados paliativos.",
        },
        {
          question: "¿Quiénes pueden acceder?",
          answer:
            "Todas las mujeres nacidas en el Estado de Nuevo León que no cuentan con seguridad social.",
        },
        {
          question: "¿Qué servicios incluye el CUCMA (Cobertura Universal contra el Cáncer de Mama)?",
          answer:
            "El programa incluye estudios de tamizaje, diagnóstico, tratamiento y seguimiento hasta lograr la recuperación de las pacientes o bien brindar los cuidados paliativos en caso de que la enfermedad no sea curable.",
        },
        {
          question: "¿La atención incluye medicamentos?",
          answer:
            "Sí. Las pacientes que sean diagnosticadas con cáncer de mama mediante el programa podrán tener un tratamiento integral.",
        },
        {
          question:
            "¿Si yo ya fui diagnosticada con cáncer de mama puedo acceder a los servicios?",
          answer:
            "Si, siempre y cuando no cuente con algún tipo de seguridad social.",
        },
        {
          question: "¿Cómo es el financiamiento?",
          answer:"El Gobierno del Estado a través de la Secretaría de Salud se hará cargo de los gastos que implique la atención desde los estudios de tamizaje y diagnóstico, hasta el tratamiento y seguimiento de la enfermedad.",
            
        },
        {
          question: "¿Cómo paciente, ¿tendré que pagar algo?",
          answer:
            "Las pacientes solo deben cubrir el traslado de casa a  la unidad médica u hospital para recibir la atención.",
        },
        {
          question:
            "¿Cuáles son las causas por las que puedo perder el servicio?",
          answer:
            "En caso de abandonar el tratamiento o adquirir alguna derechohabiencia o seguridad social, ya que serán estas instituciones las encargadas de brindar el tratamiento.",
        },
        {
          question: "¿Cómo puedo acceder a los servicios?",
          answer:
            "Para acceder a los servicios puedes comunicarte al 81 8130 0005 o visitar el portal https://www.saludnl.gob.mx/cancerdemama",
        },
        {
          question: "¿En qué hospitales se brinda el servicio?",
          answer:
            "En los Centros de Salud, Unidades de Especialidades Médicas y Hospitaes de los Servicios de Salud de Nuevo León, el Hospital Universitario “Dr. José Eleuterio González” y Hospital San José, TecSalud.",
        },
        {
          question: "¿Cuáles son los requisitos para acceder al programa?",
          answer:
            "Haber nacido en el Estado de Nuevo León y no contar con algún tipo de seguridad social.",
        },
        {
          question: "¿Puedo acceder al servicio si soy de otro estado?",
          answer:
            "Por el momento la atención solo será para pacientes que hayan nacido en el estado de Nuevo León.",
        },
        {
          question: "¿Hay lista de espera para acceder al servicio?",
          answer:
            "No.",
        },
        {
          question:
            "¿Me pueden ayudar si solo requiero medicamentos que no encuentro en mi unidad de salud?",
          answer:
            "No. El tratamiento es integral, y sólo será para las mujeres que se encuentren registradas en el programa.",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#fuentes {
  margin-top: 36px;
}

.accordion-header .accordion-button {
  font-weight: 500;
  background-color: rgba(243, 158, 197, 0.4);
}

.accordion-button:focus {
}

.accordion{
  padding: 16px;
}

.accordion-body {
  margin-bottom: 16px;
}

#title{
  font-size: 1.8rem;
  margin-top: 16px;
}
</style>
